module.exports = __webpack_public_path__ + "img/ic_pickup.c71385ab.png";